"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VeteranBuiltLegacy() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: portraitRef,
    isVisible: portraitVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: philosophyRef,
    isVisible: philosophyVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const milestones = [{
    year: "2018",
    caption: "Founded in Vacaville, CA, with a mission to modernize local business operations."
  }, {
    year: "2020",
    caption: "Launched our proprietary 24/7 AI answering and booking engine."
  }, {
    year: "2022",
    caption: "Expanded to full-service digital branding and custom web development."
  }, {
    year: "2024",
    caption: "Scaling local businesses to premium status through automated growth."
  }];
  const philosophy = [{
    title: "Precision Automation",
    body: "We replace manual chaos with automated precision. Our AI systems ensure no lead is ever missed, capturing every opportunity 24/7."
  }, {
    title: "Tactical Design",
    body: "Your digital presence is your frontline. We build custom, high-performance websites that convert visitors into loyal, long-term clients."
  }, {
    title: "Veteran Discipline",
    body: "Built on a foundation of military-grade discipline and father-son integrity, we treat your business like it's our own."
  }];
  return <section data-section-id="3146" id="veteran-built-legacy" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="px-6 md:px-12 lg:px-20 pt-32 md:pt-48 pb-24 md:pb-32">
        {}
        <div ref={headlineRef} className={`relative mb-20 md:mb-32 transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs md:text-sm uppercase text-muted-foreground mb-8 tracking-widest">— EST. 2026 · VACAVILLE, CA</p>
          <h2 className="font-default font-bold leading-[0.85] text-foreground md:translate-x-[8%]" style={{
          fontSize: "clamp(6rem, 14vw, 14rem)",
          letterSpacing: "-0.05em"
        }}>
            LEGACY<span style={{
            color: "var(--primary)"
          }}>.</span>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-24 md:mb-32">
          {}
          <div ref={portraitRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${portraitVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative inline-block w-full">
              <div className="absolute -top-3 -left-3 w-full h-full pointer-events-none" style={{
              border: "12px solid var(--primary)"
            }} aria-hidden="true" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/IMG_8461-rotated.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_guyz_founders_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_guyz_founders_portrait.png-wvc-sizes" alt="AI Guyz father and son team in Vacaville" loading="lazy" decoding="async" className="relative w-full h-auto object-cover aspect-[3/4] bg-primary" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/IMG_8461-rotated.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/IMG_8461-rotated.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/IMG_8461-rotated.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/IMG_8461-rotated.png" src="https://diverse-serval.10web.cloud/wp-content/uploads/2026/06/IMG_8461-rotated.jpeg" src="https://diverse-serval.10web.cloud/wp-content/uploads/2026/06/Joey-and-I.png" src="https://diverse-serval.10web.cloud/wp-content/uploads/2026/06/Gemini_Generated_Image_kzv0pbkzv0pbkzv0.png" src="https://diverse-serval.10web.cloud/wp-content/uploads/2026/06/Joey-and-I.png" />
            </div>
            <p className="font-mono text-xs uppercase text-muted-foreground mt-6 tracking-widest">
              Father & Son — AI Guyz Founders
            </p>
          </div>

          {}
          <div ref={narrativeRef} className={`lg:col-span-7 transition-all duration-1000 ease-out delay-200 ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default italic text-foreground mb-12 leading-[1.3]" style={{
            fontSize: "clamp(1.25rem, 2vw, 1.75rem)"
          }}>
              It began with a simple observation: local businesses were losing thousands in revenue simply by missing phone calls.
            </p>

            <p className="font-default text-foreground/90 text-lg leading-relaxed mb-8"><span className="float-left font-default font-bold mr-3 mt-2 leading-[0.8]" data-ast-id="f:/src/pages/OurMission/sections/VeteranBuiltLegacy.tsx|sig:hqg51r" data-ast-start="4801" data-ast-end="5142" style={{
              fontSize: '5rem',
              color: 'var(--primary)',
              letterSpacing: '-0.05em'
            }}>W</span>e are AI Guyz, a veteran-owned and operated, father and son, business based in Vacaville, CA. We saw the struggle of local entrepreneurs trying to balance operations with customer acquisition. We decided to build the solution. By combining advanced AI answering services with premium web design, we provide the services that turns small businesses into industry leaders.</p>

            <div className="relative pl-6 my-10 lg:-ml-6">
              <div className="absolute left-0 top-0 bottom-0 w-1" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
              <p className="font-default italic text-foreground text-xl md:text-2xl leading-snug">
                "We don't just build tools; we build the infrastructure for your business to scale on autopilot."
              </p>
            </div>

            <p className="font-default text-foreground/90 text-lg leading-relaxed mb-8">Today, we serve as the tactical partner for local businesses. We handle the technical heavy lifting—from 24/7 AI booking to custom branding—so you can focus on delivering your service.</p>

            <p className="font-default text-foreground/90 text-lg leading-relaxed">
              Our mission is simple: to ensure that no local business ever misses a client again. We bring the precision of enterprise-level technology to the local level.
            </p>
          </div>
        </div>

        {}
        
      </div>

      {}
      <div ref={philosophyRef} style={{
      backgroundColor: "hsl(230 12% 12%)",
      color: "hsl(0 0% 98%)"
    }} className={`px-6 md:px-12 lg:px-20 py-24 md:py-40 transition-all duration-1000 ease-out ${philosophyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 md:mb-24">
          
          <h3 className="font-default font-bold uppercase leading-[0.9] !text-center" style={{
          fontSize: "clamp(3rem, 8vw, 7rem)",
          letterSpacing: "-0.05em",
          color: "hsl(0 0% 98%)"
        }}>
            Our Approach
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {philosophy.map((p, i) => <div data-index={i} key={p.title} className="flex flex-col">
              <div className="h-px w-16 mb-8" style={{
            backgroundColor: "hsl(0 0% 98%)"
          }} aria-hidden="true" />
              <h4 className="font-default font-bold uppercase text-2xl mb-6" style={{
            letterSpacing: "-0.03em",
            color: "hsl(0 0% 98%)"
          }}>
                {p.title}
              </h4>
              <p className="font-default text-lg leading-relaxed" style={{
            color: "hsl(230 10% 70%)"
          }}>
                {p.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}